export class WidgetTemplateColorValueConverter {
  toView(color: string | undefined, isInDashboard: boolean) {
    return color ?? (isInDashboard ? 'var(--dyn-default-color)' : '#000000');
  }
}
